/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PublicMatchOperationV2Team } from './PublicMatchOperationV2Team';
import {
    PublicMatchOperationV2TeamFromJSON,
    PublicMatchOperationV2TeamFromJSONTyped,
    PublicMatchOperationV2TeamToJSON,
    PublicMatchOperationV2TeamToJSONTyped,
} from './PublicMatchOperationV2Team';

/**
 * 
 * @export
 * @interface PublicMatchOperationV2Participants
 */
export interface PublicMatchOperationV2Participants {
    /**
     * 
     * @type {PublicMatchOperationV2Team}
     * @memberof PublicMatchOperationV2Participants
     */
    teamA: PublicMatchOperationV2Team;
    /**
     * 
     * @type {PublicMatchOperationV2Team}
     * @memberof PublicMatchOperationV2Participants
     */
    teamB: PublicMatchOperationV2Team;
}

/**
 * Check if a given object implements the PublicMatchOperationV2Participants interface.
 */
export function instanceOfPublicMatchOperationV2Participants(value: object): value is PublicMatchOperationV2Participants {
    if (!('teamA' in value) || value['teamA'] === undefined) return false;
    if (!('teamB' in value) || value['teamB'] === undefined) return false;
    return true;
}

export function PublicMatchOperationV2ParticipantsFromJSON(json: any): PublicMatchOperationV2Participants {
    return PublicMatchOperationV2ParticipantsFromJSONTyped(json, false);
}

export function PublicMatchOperationV2ParticipantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicMatchOperationV2Participants {
    if (json == null) {
        return json;
    }
    return {
        
        'teamA': PublicMatchOperationV2TeamFromJSON(json['teamA']),
        'teamB': PublicMatchOperationV2TeamFromJSON(json['teamB']),
    };
}

export function PublicMatchOperationV2ParticipantsToJSON(json: any): PublicMatchOperationV2Participants {
    return PublicMatchOperationV2ParticipantsToJSONTyped(json, false);
}

export function PublicMatchOperationV2ParticipantsToJSONTyped(value?: PublicMatchOperationV2Participants | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teamA': PublicMatchOperationV2TeamToJSON(value['teamA']),
        'teamB': PublicMatchOperationV2TeamToJSON(value['teamB']),
    };
}

